"use client"

import {LoadingOutlined} from "@ant-design/icons"
import styles from "./loading.module.sass"

export default function Loading() {
  // Or a custom loading skeleton component
  return (
    <div className={styles.container} data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
      <div>
        <LoadingOutlined style={{fontSize: 64}} data-sentry-element="LoadingOutlined" data-sentry-source-file="loading.tsx" />
      </div>
      <div style={{fontSize: 24}}>Loading...</div>
    </div>
  )
}
